<script setup lang="ts">
// Per-team overview: shows the tools of one section (Support / PE / Dev) as cards. Which section is
// determined by the route's `sectionKey` meta, so a single component serves /support, /pe, /marketing and /dev.
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { getSections, type SectionTool } from "../config/sections";

const route = useRoute();
const { t } = useI18n();

const section = computed(() => getSections().find((s) => s.key === route.meta.sectionKey));

function toolLabel(tool: SectionTool): string {
    return tool.labelKey ? t(tool.labelKey) : (tool.label ?? "");
}
</script>

<template>
    <div v-if="section" class="my-8">
        <h1 class="page-title mb-1"><i :class="section.icon" class="mr-2" />{{ section.title }}</h1>
        <p class="text-content-muted mt-0 mb-6">{{ section.description }}</p>
        <div class="grid grid-cols-12 gap-4">
            <div v-for="tool in section.tools" :key="tool.to" class="col-span-12 md:col-span-4">
                <router-link :to="tool.to" class="no-underline">
                    <Card class="h-full cursor-pointer">
                        <template #content>
                            <div class="flex items-center gap-4">
                                <i :class="tool.icon" style="font-size: 1.25rem" />
                                <span class="font-medium text-content">{{ toolLabel(tool) }}</span>
                            </div>
                        </template>
                    </Card>
                </router-link>
            </div>
        </div>
    </div>
</template>
